import React, { useEffect } from 'react';
import styles from './style.module.css';
import { Forms } from 'components';
import { AddMedicationPageContent } from 'services/content';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import infoCircle from 'assets/info-circle.svg';

const AddMedication = () => {
  const history = useHistory();

  const isP9 = useSelector((state) => state.patient.isP9);

  useEffect(() => {
    if (isP9) history.push('/pharmacy/dashboard');
  }, [history, isP9]);

  return (
    <div className={`coop-l-container genericSpacer`}>
      <div className={`coop-l-medium-${8} coop-l-large-${6} ${styles.gridContent}`}>
        <h2 className={styles.header}>{AddMedicationPageContent.headingText}</h2>
        <div className={styles.infoContainer}>
          <img className={styles.infoContainer__icon} src={infoCircle} alt="Info Circle" />
          <p className={styles.infoContainer__paragraph}>{AddMedicationPageContent.infoBoxText}</p>
        </div>
        <Forms.AddMedicationForm />
      </div>
    </div>
  );
};

export default AddMedication;
